import { ShoppingBag, Gem, Gamepad2, Globe, Crown, Target, Bot, Building2, Sparkles, Palette, Rocket, Camera } from "lucide-react";

export const ICONS = { ShoppingBag, Gem, Gamepad2, Globe, Crown, Target, Bot, Building2, Sparkles, Palette, Rocket, Camera };

const FROM = { ru: "от", en: "from", cn: "起价" };
const MONTH = { ru: "/ мес", en: "/ mo", cn: "/ 月" };

export const rub = (n) => `${Number(n || 0).toLocaleString("ru-RU")} ₽`;

export function formatPrice(service, lang = "ru") {
  const base = `${FROM[lang] || FROM.ru} ${rub(service.price)}`;
  return service.period === "month" ? `${base} ${MONTH[lang] || MONTH.ru}` : base;
}

export const tr = (obj, field, lang) => obj[`${field}_${lang}`] || obj[`${field}_ru`] || "";

export const uploadUrl = (path) => `${process.env.REACT_APP_BACKEND_URL}${path}`;

export const fmtSize = (b) => (b > 1024 * 1024 ? `${(b / 1024 / 1024).toFixed(1)} МБ` : `${Math.round(b / 1024)} КБ`);

export const fmtDateTime = (iso) =>
  iso ? new Date(iso).toLocaleString("ru-RU", { day: "2-digit", month: "2-digit", year: "numeric", hour: "2-digit", minute: "2-digit" }) : "—";

export function toInputValue(iso) {
  if (!iso) return "";
  const d = new Date(iso);
  const p = (n) => String(n).padStart(2, "0");
  return `${d.getFullYear()}-${p(d.getMonth() + 1)}-${p(d.getDate())}T${p(d.getHours())}:${p(d.getMinutes())}`;
}

export const fromInputValue = (v) => (v ? new Date(v).toISOString() : null);
